import { BookOpen } from 'lucide-react';

import JaberAlkhawaterLogo from '../assets/jaber-alkhawater-logo.png';

const Footer = () => {
	return (
		<footer className="border-t-2 border-t-primary/20 py-8">
			<div className="container mx-auto text-center">
				<p
					style={{
						color: '#1b5e20',
						fontSize: '16px',
					}}>
					© {new Date().getFullYear()} منصة جبر الخواطر التعليمية
				</p>
			</div>
		</footer>
	);
};

export default Footer;
